import { helper } from '../../utils'
import { loadLanguageAsync } from '@/i18n'

export default {
  created () {
    loadLanguageAsync()
  },
  computed: {
    resetPwdMsg () {
      return this.$store.state.resetPwdDone
    }
  },
  methods: {
    checkCreds (email, password) {
      const username = email

      this.resetResponse()
      this.$store.commit('SET_USER', username)
      return this.$api.login({ email, password })
        .then(({ id, token }) => {
          this.$store.commit('SET_TOKEN', token)
          this.$cookie.set('sid', token, { expires: '30D' })
          if (window.localStorage) {
            window.localStorage.setItem('uid', id)
            window.localStorage.setItem('user', username)
            window.localStorage.setItem('token', token)
          }
        })
        .then(() => this.$api.checkToken())
        .then(() => this.$message.closeAll())
        .then(() => this.$router.push('/device'))
        .catch(error => {
          this.response = error.data
          helper.clearLoginData(this)
          this.loading = false
        })
    },
    forgetPwd () {
      this.$store.commit('RESET_PWD_DONE', false)
      this.$router.push('/reset')
    },
    resetResponse () {
      this.$store.commit('RESET_PWD_DONE', false)
      this.response = ''
    },
    validateForm () {
      return this.$validator.validateAll().then((valid) => {
        if (valid) {
          const { email, password } = this
          this.loading = true
          return this.checkCreds(email, password)
        }
      })
    }
  },
  name: 'Login',
  data (router) {
    return {
      email: '',
      loading: false,
      password: '',
      response: '',
      section: 'Login'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/Login.js